/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Prev_PageInputs */

const vi_common_prev_page = /** @type {(inputs: Common_Prev_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang trước`)
};

/**

* @param {Common_Prev_PageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_prev_page = /** @type {((inputs?: Common_Prev_PageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Prev_PageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_prev_page(inputs)
});